// extracted by mini-css-extract-plugin
export var content = "_bs-3";
export var list = "_bs-4";
export var settingsContent = "_bs-7";
export var settingsPanel = "_bs-8";
export var state = "_bs-6";
export var triggerBadge = "_bs-2";
export var triggerButton = "_bs-1";
export var triggerShell = "_bs-0";
export var unreadDot = "_bs-5";